<template>
  <p class="icon-box flex items-center justify-center" :class="className">
    <i class="weight-normal iconfont" :class="iconName"></i>
  </p>
</template>

<script>
export default {
  props: {
    iconName: String,
    className: String,
    size: String,
  }
}
</script>

<style lang="less" scoped>
.icon-box{
  background: #D8271C;
  color: #fff;
  width: .42rem;
  height: .42rem;
  border-radius: 50%;
  margin-right: 12px;
  
  .iconfont{ 
    font-size: inherit;
  }
}
</style>>
